import { backendConfig } from "../config/BackendConfig";
import { encryptToken } from "../utils/utils";
import { axiosInstance } from "./AxiosInterceptor";
import axios from "axios";

/**
 * @param {
 *  userId: userId
 *  requestedByUserId
 *  roleName
 *  siteList
 *  tenantId
 * } queryParam
 * @returns Promise
 */
export const updateUser = (queryParam) => {
  /**End Point:- editUser**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.updateUserAccess,
    queryParam
  );
};

export const setUserPreference = (queryParam) => {
  /**End Point:- setUserPreference**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.setUserPreference,
    queryParam
  );
};

export const setUserPreferenceBeforeSignin = (queryParam, username) => {
  /**End Point:- setUserPreference**/
  const key = { token: backendConfig.SECRET_KEY_TO_ENCRYPT };
  const encryptedToken = encryptToken(key);
  return axios.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.setUserPreference,
    {
      ...queryParam,
      apiVersion: [2, 3],
      requestedUserId: username,
      token: encryptedToken,
    },
    {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": backendConfig.API_KEY,
      },
    }
  );
};

/**
 * @param {
 *  attribute: string [email]
 *  attribute_value: string [email id to be delete]
 * } queryParam
 * @returns Promise
 */
export const deleteUnConfirmedUser = (queryParam) => {
  /**End Point:- deleteUnConfirmedUser**/
  return axios.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.deleteUnconfirmedUser,
    queryParam,
    {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": backendConfig.API_KEY,
      },
    }
  );
};

/**
 * @param {
 *  inviteId: string
 * } queryParam
 * @returns Promise
 */
export const getUserInvitationDetails = (queryParam) => {
  /**End Point:- getUserInvitationDetails**/
  return axios.post(
    backendConfig.API_URL +
      backendConfig.API_END_POINTS.getUserInvitationDetails,
    queryParam,
    {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": backendConfig.API_KEY,
      },
    }
  );
};

/**
 * @param {
 *  cognitoId: string
 * } queryParam
 * @returns Promise
 */
export const getDetailsForUser = (queryParam) => {
  /**End Point:- getDetailsForUser**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.getDetailsForUser,
    queryParam
  );
};

/**
 * @param {
*  cognitoId: string
* } queryParam
* @returns Promise
*/
export const getInitialCombinedDetails = (queryParam) => {
 /**End Point:- getDetails**/
 return axiosInstance.post(
   backendConfig.API_URL + backendConfig.API_END_POINTS.getDetails,
   queryParam
 );
};

export const sendUserInvite = (queryParam) => {
  /**End Point:- sendUserInvite**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.inviteUsers,
    queryParam
  );
};

export const getUsersForTenant = (queryParam) => {
  /**End Point:- getUsersForTenant**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.getUsers,
    queryParam
  );
};

export const deleteDisableUserByCognitoId = (queryParam) => {
  /**End Point:- deleteDisableUserByCognitoId**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.toggleUserStatus,
    queryParam
  );
};


export const setClientData = (queryParam) => {
  /**End Point:- setClientData**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.setClientData,
    queryParam
  );
};

/**
 * @param {
* "cognitoId": string,
* "attributeName": string,
* "attributeValue": string,
* "requestedUserId": string,
* } queryParam
* @returns Promise
*/

export const updateUserAttribute = (queryParam) => {
 /**End Point:- updateUserAttribute**/
 return axiosInstance.post(
   backendConfig.API_URL + backendConfig.API_END_POINTS.updateUserDetails,
   // backendConfig.API_URL + backendConfig.API_END_POINTS.toggleUserStatus,
   queryParam
 );
};


/**
 * @param {
* "cognitoId": string,
* "attributeName": string,
* "attributeValue": string,
* "requestedUserId": string,
* } queryParam
* @returns Promise
*/

export const setUserProfileImage = (queryParam) => {
  /**End Point:- setUserProfileImage**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.setUserProfileImage,
    queryParam
  );
};

/**
 * @param {
* "cognitoId": string,
* "requestedUserId": string,
* } queryParam
* @returns Promise
*/

export const deleteUserProfileImage = (queryParam) => {
  /**End Point:- deleteUserProfileImage**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.deleteUserProfileImage,
    queryParam
  );
};
